<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog"
      content-class="dialog"
      persistent max-width="730">      
      <v-card
        style="max-height: 100%;"
      >
        <v-card-title class="headline">
          <h1>Personalizar texto (LGPD)</h1>
          <v-btn class="close-modal" @click="close">
            <i class="fal fa-times"></i>
          </v-btn>
        </v-card-title>
        <v-card-text style=" padding:20px; justify-content: center;">
          <v-layout column gap-xl ml-3 mt-3 mw-full style="padding: 20px">
                <v-flex class="mb-3">
                    <vue-editor
                      :editor-toolbar="customToolbar"
                      v-model="text"
                    />
                </v-flex>
              </v-layout>
        </v-card-text>
        <v-card-actions class="pa-0">
          <div class="footer-modal-atividades">
            <v-btn
              flat
              round
              color="white"
              class="btn btn-default px-5"
              large
              @click="close"
            >Cancelar</v-btn>
            <v-btn
              flat
              round
              color="white"
              class="btn btn-primary px-5"
              large
              @click="save"
            >Salvar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script type="plain/text">
// Services
import CompanyService from "@/scripts/services/company.service.js";

// Editor
import { VueEditor } from "vue2-editor";

export default {
  props: {
    companyId: String,
    dialog: Boolean,
  },
  components: {
    VueEditor,
  },
  data() {
    return {
      companyService: new CompanyService(),
      company: {},
      text: null,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },
  async created() {
    this.company = this.companyService.find((res) => {
      this.company = res;
      this.getText();
    }, this.companyId);
  },
  methods: {
    close() {
      this.$emit("close")
    },
    save() {
      this.$emit('updateText', this.text)
      this.close();
      this.company.lgpdText = this.text;
    },
    getText() {
      this.text = this.company.lgpdText ? this.company.lgpdText : 'Deseja receber comunicações futuras desta organização?';
    }
  },
};
</script>